import FantasyPlayerDetailedStatsMetaModel from "./Meta/FantasyPlayerDetailedStatsMetaModel";
import PlayerDetailedStatsModel from "./PlayerDetailedStatsModel";

export default class FantasyPlayerDetailedStatsModel {
  public meta: FantasyPlayerDetailedStatsMetaModel =
    new FantasyPlayerDetailedStatsMetaModel();
  public data: PlayerDetailedStatsModel[] = [];
}
